import styled from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'

export const MainContainer = styled.section`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${mainColors.neutralExtraLight};

  .rdr-DateRange {
    height: calc(100% - 4px);
  }

  .rdr-DateRange-container {
    justify-content: flex-start !important;
  }
`
